import { render, staticRenderFns } from "./commandCell.vue?vue&type=template&id=2264788a&scoped=true"
import script from "./commandCell.vue?vue&type=script&lang=js"
export * from "./commandCell.vue?vue&type=script&lang=js"
import style0 from "./commandCell.vue?vue&type=style&index=0&id=2264788a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2264788a",
  null
  
)

export default component.exports